(function() {
    'use strict';
    angular.module('app')
        .controller('CrossDockController', function($scope, $location) {});
})();


// WEBPACK FOOTER //
// ./js/controllers/CrossDockController.js